import { render } from "./Styleguide-FieldUsage-Checkbox.vue?vue&type=template&id=ed8c3f24"
import script from "./Styleguide-FieldUsage-Checkbox.vue?vue&type=script&lang=js"
export * from "./Styleguide-FieldUsage-Checkbox.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__